<template>
    <div>
        <v-autocomplete v-if="!booking.damage || isEdit" v-model="selectedRepairs" label="Search for repair type" :items="repairs" return-object item-text="repair" multiple chips deletable-chips />
      <v-btn @click="createEmptyRepair" color="success">Create Empty</v-btn>
      <div v-if="selectedRepairs.length > 0 && renderComponent">
            <div v-for="(repair, index) in selectedRepairs" :key="index" class="mt-2" style="width: 100%; border: 1px solid black; border-radius: 5px; padding: 10px">
                <v-text-field v-model="repair.repairDetail" label="Repair Detail" />
                <div v-if="repair.repair !== 'Wheels' && repair.repair !== 'Courtesy Car'">
                    <v-row>
                        <v-col>
                            <v-checkbox color="primary" v-model="repair.scratchDent" label="Scratch & Dent" />
                            <v-text-field v-model="repair.damageCommentsScratchDent" label="Damage Comments" />
                        </v-col>
                        <v-col>
                            <v-checkbox color="primary" v-model="repair.blend" label="Blend Colour" />
                            <v-text-field v-model="repair.damageCommentsBlend" label="Damage Comments" />
                        </v-col>
                        <v-col>
                            <v-checkbox color="primary" v-model="repair.scratch" label="Scratch" />
                            <v-text-field v-model="repair.damageCommentsScratch" label="Damage Comments" />
                        </v-col>
                        <v-col>
                            <v-checkbox color="primary" v-model="repair.chips" label="Chips" />
                            <v-text-field v-model="repair.damageCommentsChips" label="Damage Comments" />
                        </v-col>
                        <v-col>
                            <v-checkbox color="primary" v-model="repair.dent" label="Dent" />
                            <v-text-field v-model="repair.damageCommentsDent" label="Damage Comments" />
                        </v-col>
                        <v-col>
                            <v-checkbox color="primary" v-model="repair.trim" label="Trim" />
                            <v-text-field v-model="repair.damageCommentsTrim" label="Damage Comments" />
                        </v-col>
                    </v-row>
                </div>
                <div v-if="repair.repair === 'Wheels' && repair.repair !== 'Courtesy Car'">
                    <v-row>
                        <v-col>
                            <v-checkbox v-model="repair.osf" label="OSF"/>
                            <v-checkbox v-model="repair.osr" label="OSR"/>
                        </v-col>
                        <v-col>
                            <v-checkbox v-model="repair.nsf" label="NSF"/>
                            <v-checkbox v-model="repair.nsr" label="NSR"/>
                        </v-col>
                    </v-row>
                </div>
                <v-text-field v-model.number="repair.labour" type="number" label="Labour" />
            </div>
            <v-btn @click="addRepairs" class="mt-3" color="primary">Add Repairs</v-btn>
        </div>
        <div v-if="booking.damage && booking.damage.length > 0 && !isEdit && renderComponent">
            <v-btn @click="editDamage" color="info">Edit Damage</v-btn>
            <v-data-iterator :items="booking.damage">
                <template v-slot:default="props">
                    <v-row>
                        <v-col class="mt-2" cols="12" v-for="(item, index) in props.items" :key="index">
                            <v-card>
                                <v-card-title><v-icon left>mdi-image-broken-variant</v-icon>
                                  <span v-if="item.repair !== ''">{{item.repair}}</span>
                                  <span v-if="item.repair === ''">{{item.repairDetail}}</span>
                                  - £{{item.labour}}</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" v-if="item.repair !== 'Wheels'">
                                            <div v-if="item.scratchDent">
                                                <v-checkbox disabled color="primary" v-model="item.scratchDent" label="Scratch & Dent" />
                                                <p>Comments: {{item.damageCommentsScratchDent}}</p>
                                            </div>
                                            <div v-if="item.blend">
                                                <v-checkbox disabled color="primary" v-model="item.blend" label="Blend Colour" />
                                                <p>Comments: {{item.damageCommentsBlend}}</p>
                                            </div>
                                            <div v-if="item.scratch">
                                                <v-checkbox disabled color="primary" v-model="item.scratch" label="Scratch" />
                                                <p>Comments: {{item.damageCommentsScratch}}</p>
                                            </div>
                                            <div v-if="item.chips">
                                                <v-checkbox disabled color="primary" v-model="item.chips" label="Chips" />
                                                <p>Comments: {{item.damageCommentsChips}}</p>
                                            </div>
                                            <div v-if="item.dent">
                                                <v-checkbox disabled color="primary" v-model="item.dent" label="Dent" />
                                                <p>Comments: {{item.damageCommentsDent}}</p>
                                            </div>
                                            <div v-if="item.trim">
                                                <v-checkbox disabled color="primary" v-model="item.trim" label="Trim" />
                                                <p>Comments: {{item.damageCommentsTrim}}</p>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" v-if="item.repair === 'Wheels'">
                                            <v-row>
                                                <v-col>
                                                    <v-checkbox disabled v-model="item.osf" label="OSF"/>
                                                    <v-checkbox disabled v-model="item.osr" label="OSR"/>
                                                </v-col>
                                                <v-col>
                                                    <v-checkbox disabled v-model="item.nsf" label="NSF"/>
                                                    <v-checkbox disabled v-model="item.nsr" label="NSR"/>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>
            </v-data-iterator>
        </div>
    </div>
</template>

<script>
    import repairs from "../../../../helper/repairs";
    import {EventBus} from "../../../../EventBus";

    export default {
        name: "RsDamage",
        data() {
            return {
                repairs: repairs.getRepairs(),
                selectedRepairs: [],
                isEdit: false,
                renderComponent: true
            }
        },
        props: {
            booking: Object
        },
        methods: {
            addRepairs() {
                this.isEdit = false;
                this.booking.damage = this.selectedRepairs;
                this.selectedRepairs = [];
                EventBus.$emit('damage-selected');
            },
            editDamage() {
                this.isEdit = true;
                this.selectedRepairs = this.booking.damage;
            },
          createEmptyRepair() {
            this.selectedRepairs.push({
              repair: '',
              repairDetail: '',
              scratchDent: false,
              blend: false,
              scratch: false,
              chips: false,
              dent: false,
              trim: false,
              osr: false,
              nsr: false,
              osf: false,
              nsf: false,
              identify: '',
              damageCommentsScratchDent: '',
              damageCommentsBlend: '',
              damageCommentsScratch: '',
              damageCommentsChips:'',
              damageCommentsDent: '',
              damageCommentsTrim: '',
              labour: null
            })
          },
            forceRerender() {
                // Remove my-component from the DOM
                this.renderComponent = false;

                this.$nextTick(() => {
                    // Add the component back in
                    this.renderComponent = true;
                });
            },
        },
        mounted() {
            EventBus.$on('reset-booking', () => {
                this.selectedRepairs = [];
                this.repairs = null;
                this.repairs = repairs.getRepairs();
                this.forceRerender();
            });
        }
    }
</script>

<style scoped>

</style>
